import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ClientLoginDataUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getLoginDataForOtp(req);
    }
}
export default ClientLoginDataUseCase;
